export default function Canvas_Radial_Gradient() {
  return (
    <div>
      <h1>Canvas_Radial_Gradient Component</h1>
    </div>
  );
}
